<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'EntitiesDropDownFormationListItem'
});
</script>
<template>
  <ka-container
    code="drop-down-formation"
    :options="options">
    <ka-text code="text">
      <span v-html="dropDownFormationItem.Text" />
    </ka-text>
  </ka-container>
</template>

<script setup lang="ts">
import { syncEntityStore } from 'kapix-components-vue3'
import type { IPropOptions } from 'kapix-components-vue3'
import { entitiesDropDownFormationListItemComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--list-item-e0')
const component = entitiesDropDownFormationListItemComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  dropDownFormation?: PartialEntity<Kapix.Entity.IDropDownFormation>
  options?: IPropOptions
}>(), {
  dropDownFormation: undefined,
  options: undefined
})

const dropDownFormationItem = syncEntityStore<Partial<Kapix.Entity.IDropDownFormation>>(componentInstance, {
  props,
  propName: 'dropDownFormation',
  defaultValue: {}
})
</script>
